import React from "react";
import { LocaleProvider } from "../contexts/LocaleContext";

interface LocaleWrapperProps {
    children: React.ReactNode;
}

// Wrapper component yang memastikan LocaleProvider selalu tersedia
const LocaleWrapper: React.FC<LocaleWrapperProps> = ({ children }) => {
    return <LocaleProvider>{children}</LocaleProvider>;
};

export default LocaleWrapper;
